import moment from 'moment';
import React from 'react';
import { Button, Divider, Form, Grid, TextArea } from 'semantic-ui-react';

import { clienteApi } from 'src/api';
import { Contexto } from 'src/contexto';
import ModalBase from './Componentes/ModalBase';
import MontoEIntereses from './MontoEIntereses';
import Pago from './Pago';
import { rutEsValido } from './rut';
import {
    ComandoIngresarPagoEventual,
    MetodosDePago,
    MotivoPagoEventual,
    Pago as PagoCommon,
} from './tipos';

function validarRut(posibleRut: string) {
    return posibleRut.length > 0 && rutEsValido(posibleRut);
}

interface OtroMotivoProps {
    motivo: MotivoPagoEventual;
    otroMotivo: string;
    alCambiarCampo(nombreDelCampo: string, valor: string | boolean): void;
}

const OtroMotivo: React.FunctionComponent<OtroMotivoProps> = props => {
    const { alCambiarCampo, motivo, otroMotivo } = props;
    if (motivo === 'otro') {
        return (
            <div>
                <Form.Input
                    label='Otro motivo'
                    required
                    value={otroMotivo}
                    onChange={(_e, { value }) => {
                        alCambiarCampo('otroMotivo', value);
                    }}
                />
                <Divider hidden />
            </div>
        );
    } else {
        return null;
    }
};

interface State {
    readonly cargando: boolean;
    readonly datos: ReadonlyArray<PagoCommon>;

    readonly motivo: MotivoPagoEventual;
    readonly otroMotivo: string;

    readonly metodoDePago: MetodosDePago;
    readonly monto: number;
    readonly interes: number;
    readonly numeroDeBoleta: string;
    readonly fechaRecepcionPago: string;
    readonly numeroDeDeposito: string;
    readonly observaciones: string;

    readonly idInstitucionCheque: string;
    readonly numeroDeCheque: string;
    readonly numeroDeCuentaCheque: string;
    readonly nombreTitularCheque: string;
    readonly rutTitularCheque: string;
    readonly fechaCheque: string;
    readonly esDeTercerosCheque: boolean;
    readonly rutEsValido: boolean;

    readonly tipoDeCuenta: '' | 'corriente' | 'vista' | 'chequera';
    readonly idInstitucionTransferencia: string;
    readonly numeroDeCuentaTransferencia: string;
    readonly nombreDelTitularTransferencia: string;
    readonly rutTitularTransferencia: string;
    readonly esDeTercerosTransferencia: boolean;

    readonly tipoDeTarjeta: 'debito' | 'credito';
    readonly idInstitucionTarjeta: string;
    readonly tipoDeTarjetaDeCredito: 'visa' | 'mastercard' | 'americanexpress';
    readonly numeroDeCuotasCredito: number;

    readonly pagando: boolean;
    readonly error: boolean;
}

interface PagosEventualesProps {
    nombreCompletoApoderado: string;
    rutPasaporte: string;
    idPlanDePago: string;
    alRealizarPago(): void;
}

const stateInicial: State = {
    cargando: true,
    datos: [],

    motivo: 'reposicion-material',
    otroMotivo: '',

    metodoDePago: 'efectivo',
    numeroDeDeposito: '',
    monto: 0,
    interes: 0,
    numeroDeBoleta: '',
    fechaRecepcionPago: moment()
        .format()
        .slice(0, 10),
    observaciones: '',

    idInstitucionCheque: '',
    numeroDeCheque: '',
    numeroDeCuentaCheque: '',
    nombreTitularCheque: '',
    rutTitularCheque: '',
    fechaCheque: '',
    esDeTercerosCheque: false,
    rutEsValido: false,

    tipoDeCuenta: '',
    idInstitucionTransferencia: '',
    numeroDeCuentaTransferencia: '',
    nombreDelTitularTransferencia: '',
    rutTitularTransferencia: '',
    esDeTercerosTransferencia: false,

    tipoDeTarjeta: 'debito',
    idInstitucionTarjeta: '',
    tipoDeTarjetaDeCredito: 'visa',
    numeroDeCuotasCredito: 1,

    pagando: false,
    error: false,
};

export class PagosEventuales extends React.Component<PagosEventualesProps, State> {
    public static readonly contextType = Contexto;
    public readonly context!: React.ContextType<typeof Contexto>;

    // tslint:disable:member-ordering
    private readonly rutOriginalEsInvalido = !validarRut(this.props.rutPasaporte);

    public state: State = {
        ...stateInicial,
        nombreTitularCheque: this.props.nombreCompletoApoderado,
        rutTitularCheque: this.rutOriginalEsInvalido ? '' : this.props.rutPasaporte,
    };

    public render() {
        const { nombreCompletoApoderado, rutPasaporte } = this.props;
        const {
            motivo,
            otroMotivo,

            metodoDePago,
            numeroDeDeposito,
            monto,
            interes,
            numeroDeBoleta,
            fechaRecepcionPago,
            observaciones,

            idInstitucionCheque,
            numeroDeCheque,
            numeroDeCuentaCheque,
            nombreTitularCheque,
            rutTitularCheque,
            fechaCheque,
            esDeTercerosCheque,

            tipoDeCuenta,
            idInstitucionTransferencia,
            numeroDeCuentaTransferencia,
            nombreDelTitularTransferencia,
            rutTitularTransferencia,
            esDeTercerosTransferencia,

            tipoDeTarjeta,
            idInstitucionTarjeta,
            tipoDeTarjetaDeCredito,
            numeroDeCuotasCredito,
        } = this.state;

        if (this.state.error) {
            return (
                <ModalBase
                    cabecera='Ocurrió un error'
                    iconoCabecera='exclamation triangle'
                    contenido='Ocurrió un error al ingresar el pago. Por favor inténtelo nuevamente'
                    acciones={
                        <Button
                            content='Entendido'
                            onClick={() => this.setState({ error: false })}
                        />
                    }
                />
            );
        }

        return (
            <div>
                <Form
                    onSubmit={async () => {
                        this.setState({ pagando: true });
                        await this.ingresarPagoEventual();
                    }}
                    loading={this.state.pagando}
                >
                    <Divider />
                    <Grid relaxed>
                        <Grid.Column width={4}>
                            <MontoEIntereses
                                monto={monto}
                                interes={interes}
                                fechaRecepcionPago={fechaRecepcionPago}
                                numeroDeBoleta={numeroDeBoleta}
                                alCambiarCampo={this.actualizarState}
                            />
                        </Grid.Column>

                        <Grid.Column width={12}>
                            <Form.Select
                                width={6}
                                label='Motivo '
                                placeholder='Seleccione'
                                options={[
                                    {
                                        value: 'reposicion-material',
                                        text: 'Reposición de material',
                                    },
                                    {
                                        value: 'reposicion-cuponera',
                                        text: 'Reposición de cuponera',
                                    },
                                    { value: 'multa', text: 'Multa' },
                                    { value: 'nivelacion', text: 'Nivelación' },
                                    { value: 'otro', text: 'Otro' },
                                ]}
                                value={motivo}
                                onChange={(_e, { value }) => {
                                    this.actualizarState('motivo', value as MotivoPagoEventual);
                                }}
                            />

                            <OtroMotivo
                                motivo={motivo}
                                otroMotivo={otroMotivo}
                                alCambiarCampo={this.actualizarState}
                            />

                            <Form.Select
                                width={6}
                                label='Forma de pago'
                                placeholder='Seleccione'
                                options={[
                                    { value: 'efectivo', text: 'Efectivo' },
                                    { value: 'tarjeta', text: 'Tarjeta' },
                                    { value: 'cheque', text: 'Cheque' },
                                    { value: 'deposito', text: 'Depósito' },
                                    { value: 'transferencia', text: 'Transferencia' },
                                ]}
                                value={metodoDePago}
                                onChange={(_e, { value }) => {
                                    this.actualizarState('metodoDePago', value as MetodosDePago);
                                }}
                            />
                            <Pago
                                metodoDePago={metodoDePago}
                                numeroDeCheque={numeroDeCheque}
                                idInstitucionCheque={idInstitucionCheque}
                                numeroDeCuentaCheque={numeroDeCuentaCheque}
                                nombreTitularCheque={nombreTitularCheque}
                                rutTitularCheque={rutTitularCheque}
                                fechaCheque={fechaCheque}
                                esDeTercerosCheque={esDeTercerosCheque}
                                nombreCompletoApoderado={nombreCompletoApoderado}
                                rutPasaporteApoderado={rutPasaporte}
                                tipoDeTarjeta={tipoDeTarjeta}
                                tipoDeTarjetaDeCredito={tipoDeTarjetaDeCredito}
                                numeroDeCuotasCredito={numeroDeCuotasCredito}
                                idInstitucionTarjeta={idInstitucionTarjeta}
                                numeroDeDeposito={numeroDeDeposito}
                                tipoDeCuenta={tipoDeCuenta}
                                idInstitucionTransferencia={idInstitucionTransferencia}
                                numeroDeCuentaTransferencia={numeroDeCuentaTransferencia}
                                nombreDelTitularTransferencia={nombreDelTitularTransferencia}
                                rutTitularTransferencia={rutTitularTransferencia}
                                esDeTercerosTransferencia={esDeTercerosTransferencia}
                                alCambiarCampo={this.actualizarState}
                            />
                        </Grid.Column>
                    </Grid>
                    <Divider />
                    <TextArea
                        placeholder='Observaciones'
                        value={observaciones}
                        onChange={(_e, { value }) => {
                            this.actualizarState('observaciones', value as string);
                        }}
                    />
                    <Divider />
                    <Form.Button
                        type='submit'
                        content='Registrar pago'
                        onClick={this.ingresarPagoEventual}
                        disabled={!this.camposSonValidos() || this.state.pagando}
                    />
                </Form>
            </div>
        );
    }

    private readonly actualizarState = (campo: string, valor: string | number | boolean) => {
        this.setState(prevState => {
            const nuevoState = { ...prevState, [campo]: valor };

            // Impide desmarcar `esDeTerceros` si el rut original no es válido
            nuevoState.esDeTercerosCheque =
                this.rutOriginalEsInvalido || nuevoState.esDeTercerosCheque;

            // Reinicia el rut cada vez que se cambia el checkbox `esDeTerceros`.
            // Si el rut original no es válido, no entra al bloque.
            if (campo === 'esDeTercerosCheque' && !this.rutOriginalEsInvalido) {
                nuevoState.rutTitularCheque = nuevoState.esDeTercerosCheque
                    ? ''
                    : this.props.rutPasaporte;
            }
            return nuevoState;
        });
    };

    private readonly camposSonValidos = () => {
        const { state } = this;
        if (state.monto === 0 || isNaN(state.monto)) {
            return false;
        }
        if (isNaN(state.interes)) {
            return false;
        }
        if (state.numeroDeBoleta.length === 0) {
            return false;
        }
        if (state.motivo === 'otro' && state.otroMotivo === '') {
            return false;
        }

        switch (state.metodoDePago) {
            case 'transferencia':
                return true;
            case 'cheque':
                if (state.idInstitucionCheque.length === 0) {
                    return false;
                }
                if (state.numeroDeCheque.length === 0) {
                    return false;
                }
                if (state.nombreTitularCheque.length === 0) {
                    return false;
                }
                if (state.rutTitularCheque.length === 0) {
                    return false;
                }
                if (state.fechaCheque.length === 0) {
                    return false;
                }
                if (state.esDeTercerosCheque && !state.rutEsValido) {
                    return false;
                }
                return true;
            case 'tarjeta':
                if (state.tipoDeTarjeta === 'credito' && state.numeroDeCuotasCredito < 1) {
                    return false;
                }
                return true;
            default:
                return true;
        }
    };

    private readonly ingresarPagoEventual = async () => {
        const { idPlanDePago } = this.props;
        const {
            motivo,
            otroMotivo,

            metodoDePago,
            monto,
            interes,
            numeroDeBoleta,
            fechaRecepcionPago,
            observaciones,

            idInstitucionCheque,
            numeroDeCheque,
            nombreTitularCheque,
            rutTitularCheque,
            fechaCheque,
            esDeTercerosCheque,

            numeroDeDeposito,

            tipoDeCuenta,
            idInstitucionTransferencia,
            numeroDeCuentaTransferencia,
            nombreDelTitularTransferencia,
            rutTitularTransferencia,
            esDeTercerosTransferencia,

            tipoDeTarjeta,
            idInstitucionTarjeta,
            tipoDeTarjetaDeCredito,
            numeroDeCuotasCredito,
        } = this.state;

        if (this.state.pagando) return;
        this.setState({ pagando: true });

        let comandoMetodoDePago: ComandoIngresarPagoEventual['metodoDePago'] | undefined;

        switch (metodoDePago) {
            case 'efectivo':
                comandoMetodoDePago = {
                    tipo: 'efectivo',
                };
                break;
            case 'deposito':
                comandoMetodoDePago = {
                    tipo: 'deposito',
                    numeroDeDeposito,
                };
                break;
            case 'transferencia':
                comandoMetodoDePago = {
                    tipo: 'transferencia',
                    tipoDeCuenta,
                    idInstitucion: idInstitucionTransferencia,
                    numeroDeCuenta: numeroDeCuentaTransferencia,
                    nombreDelTitular: nombreDelTitularTransferencia,
                    rutTitular: rutTitularTransferencia,
                    esDeTerceros: esDeTercerosTransferencia,
                };
                break;
            case 'cheque':
                comandoMetodoDePago = {
                    tipo: 'cheque',
                    idInstitucion: idInstitucionCheque,
                    numeroDeCheque,
                    nombreTitular: nombreTitularCheque,
                    rutTitular: rutTitularCheque,
                    fecha: fechaCheque,
                    esDeTerceros: esDeTercerosCheque,
                };
                break;
            case 'tarjeta':
                if (tipoDeTarjeta === 'debito') {
                    comandoMetodoDePago = {
                        tipo: 'tarjeta',
                        tipoDeTarjeta: 'debito',
                        idInstitucion: idInstitucionTarjeta,
                    };
                } else if (tipoDeTarjeta === 'credito') {
                    comandoMetodoDePago = {
                        tipo: 'tarjeta',
                        tipoDeTarjeta: 'credito',
                        idInstitucion: idInstitucionTarjeta,
                        tipoDeTarjetaDeCredito,
                        numeroDeCuotas: numeroDeCuotasCredito,
                    };
                }
                break;
            default:
                throw new Error('Se recibió un método de pago inválido');
        }

        const comando: ComandoIngresarPagoEventual = {
            idPlanDePago,
            motivo,
            otroMotivo,
            fecha: fechaRecepcionPago,
            monto,
            interes,
            numeroDeBoleta,
            observaciones,
            metodoDePago: comandoMetodoDePago!,
        };

        return clienteApi
            .ejecutar('ingresarPagoEventual', comando)
            .then(() =>
                this.setState(
                    {
                        ...stateInicial,
                        nombreTitularCheque: this.props.nombreCompletoApoderado,
                        rutTitularCheque: this.rutOriginalEsInvalido ? '' : this.props.rutPasaporte,
                    },
                    this.props.alRealizarPago,
                ),
            )
            .catch(error => {
                this.context.mostrarModalError(error);
                this.setState({ pagando: false, error: true });
            });
    };
}

export default PagosEventuales;



// WEBPACK FOOTER //
// ./src/modulos/Cobranzas/componentes/FichaDeApoderado/FormularioPagosEventuales.tsx